<header class="site-header">
  <div class="site-header__inner">
    <div class="site-header__top-row">
      <app-logo />

      <button
        class="site-header__menu-button"
        type="button"
        [class.site-header__menu-button--open]="isMenuOpen()"
        [attr.aria-expanded]="isMenuOpen()"
        aria-controls="primary-navigation"
        aria-label="Toggle navigation menu"
        (click)="toggleMenu()"
      >
        <span class="site-header__menu-line"></span>
        <span class="site-header__menu-line"></span>
        <span class="site-header__menu-line"></span>
      </button>
    </div>

    <app-nav
      id="primary-navigation"
      class="site-header__nav"
      [class.site-header__nav--open]="isMenuOpen()"
      (click)="closeMenu()"
    />
  </div>
</header>
